import { inject, getCurrentInstance, computed } from 'vue'

import { castArray, isArray, isString } from 'lodash-es'

import Throne from '../../../Throne'
import { CodeItem } from '../../types'

import OrionError from '../../../error/OrionError'

import { useThroneContext } from '../../../Throne/hooks/use-throne-context'

export default function useCode(code) {
    const throneContext = useThroneContext();

    return computed(() => {
        let codeData: Array<CodeItem> | null
        if (!code) {
            codeData = null;
        } else if (isString(code)) {
            codeData = Throne.getCode(code, throneContext?.value).value
        } else if (isArray<CodeItem>(code)) {
            codeData = code
        } else {
            throw new OrionError('code类型错误')
        }

        return codeData
    })
}